import React, { Component, Suspense } from "react";

//UI
import Typography from "@material-ui/core/Typography";
import CircularProgress from "@material-ui/core/CircularProgress";
//library
import { connect } from "react-redux";
import { Formik, Field, Form } from "formik";
import * as Yup from "yup";
import { Auth } from "aws-amplify";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import { ToastContainer } from "react-toastify";
import CssBaseline from "@material-ui/core/CssBaseline";
import Paper from "@material-ui/core/Paper";

//component
import Input from "../../Controls/Input";
import Button from "../../Controls/Button";
import Hyperlink from "../../Controls/Hyperlink";
import { setGlobalParam } from "../../reducers/reducers";
import { history } from "../../store";
import {
  CheckboxComponent,
  TextFieldComponent,
} from "../../components/FormComponent";
import { postEveryApi } from "../../actions/actions";
import DataAccessCategory from "../../Controls/Select/DataAccessCategory.json";
import _submitRequest from "./_submitRequest.login";

const VerificationSchema = Yup.object().shape({
  // code: Yup.string().required('Required'),
});
class Verification extends Component {
  useGoToLogin = (event) => {
    const { dispatch } = this.props;
    dispatch({
      type: setGlobalParam,
      storage: "login.show_forgot_component",
      response: false,
    });
  };

  resendCode = async (event) => {
    const { register_form } = this.props;
    const response = await Auth.resendSignUp(register_form.email);
    toast.success("New verification code has been sent");
  };

  async useVerifyCode(values) {
    const { dispatch, register_form } = this.props;
    try {
      const response = await Auth.confirmSignUp(
        register_form.email,
        values.code,
        { forceAliasCreation: true }
      );
      if (response == "SUCCESS") {
        this.sendEmailApproval();
        toast.success("Your email has been verified");

        dispatch({
          type: setGlobalParam,
          storage: "login.show_successVerified_component",
          response: true,
        });

        dispatch({
          type: setGlobalParam,
          storage: "login.switch_class",
          response: "",
        });
        dispatch({
          type: setGlobalParam,
          storage: "login.show_hide_class",
          response: "",
        });

        dispatch({
          type: setGlobalParam,
          storage: "login.show_verifyemail_component",
          response: false,
        });
      }
    } catch (error) {
      toast.error("Wrong Verification Code");
    }
  }

  sendEmailApproval = async () => {
    const { register_form, dispatch } = this.props;
    //let OPU = "";

    try {
      DataAccessCategory.map((item) => {
        if (register_form.access_category == item.value) {
          register_form.access_category = item.text;
        }

        if (register_form.access_category == "PDB Admin") {
          register_form.OPU = "PDB";
        } else if (register_form.access_category == "PDB Agent Company") {
          register_form.OPU = "PDB";
        } else if (register_form.access_category == "PDB Agent") {
          register_form.OPU = "PDB";
        } else if (register_form.access_category == "PETCO Admin") {
          register_form.OPU = "PETCO";
        } else if (register_form.access_category == "Surveyor") {
          register_form.OPU = "SURVEYOR";
        } else if (register_form.access_category == "PLI Admin") {
          register_form.OPU = "PLI";
        } else if (register_form.access_category == "PCG Admin") {
          register_form.OPU = "PCG";
        }
      });

      const response = await Auth.signIn(
        register_form.email,
        register_form.password
      );

      dispatch(
        postEveryApi({
          api: "/emailApproval",
          data: register_form,
        })
      );
    } catch (e) {
      Swal.fire("Error", e.message, "error");
    }
  };
  render() {
    const { verification_form, show_successVerified_component } = this.props;

    if (show_successVerified_component) {
      return <_submitRequest />;
    }

    return (
      <div className="submitRequest-inner">
        <Typography component="h1" variant="h3" className="logo-text">
          VOPS
        </Typography>
        <Typography component="h1" variant="h5">
          Verify Email
        </Typography>
        <Typography component="p" variant="div" className="text-center">
          Please enter the verification code that has been sent to your
          individual email address
        </Typography>
        <div className="login-fixed-height">
          <Formik
            initialValues={verification_form}
            validationSchema={VerificationSchema}
            onSubmit={(values, { setSubmitting }) => {
              this.useVerifyCode(values);
            }}
            render={({ values, handleSubmit }) => (
              <Form>
                <Field
                  autoFocus
                  name="code"
                  type="text"
                  label="Verification Code"
                  component={TextFieldComponent}
                />
                <br />
                <Button
                  inputLabel="Submit"
                  // inputDisabled={is_button_disabled}
                  inputOnClick={handleSubmit}
                  inputColor="primary"
                // inputLoading={is_loading_register}
                />
                <br />
                <Button
                  inputLabel="Resend verification code"
                  // inputDisabled={is_button_disabled}
                  inputOnClick={this.resendCode}
                  inputColor="primary"
                // inputLoading={is_loading_register}
                />
                <br />
              </Form>
            )}
          />
        </div>
      </div>
    );
  }
}

export default connect(
  (state) => ({ ...state.reducer.login }),
  (dispatch) => ({ dispatch })
)(Verification);



// WEBPACK FOOTER //
// ./src/containers/Login/_verifyEmail.login.js